import React, { useEffect, useState } from "react";
import AboutItem from "./AboutItem";

export default function About() {


  return (
    <section className="section blackbg" id="about">
      <h2 className="title"> QUIÉNES SOMOS </h2>
      <p className="parrafo">
      Desde 2005 estamos presentes en los medios de comunicación produciendo contenido periodístico y editorial. Desarrollamos la comercialización de todos nuestros proyectos.
      </p>
      <p className="subtitle">Nuestros servicios</p>
      <div className="list-column">
        <AboutItem img="https://img.icons8.com/ios/100/ffffff/commercial--v1.png" text="Comercialización de espacios publicitarios y auspicios en medios." />

        <AboutItem img="https://img.icons8.com/ios/50/ffffff/theatre-stage.png" text="Producciones para espectáculos y eventos." />

        <AboutItem img="https://img.icons8.com/ios/50/ffffff/source-four-par.png" text="Desarrollo integral de ecommerce para emprendedores." />

        <AboutItem img="https://img.icons8.com/ios/50/ffffff/microphone.png" text="Administración y gestión de medios de comunicación." />

        <AboutItem img="https://img.icons8.com/pastel-glyph/64/ffffff/website--v2.png" text="Comercialización y contenidos de páginas web." />

        <AboutItem img="https://firebasestorage.googleapis.com/v0/b/autoprecios-f936b.appspot.com/o/redes.png?alt=media&token=75c65b44-c145-471f-a7c6-11f344ed767a" text="Comercialización, contenidos y gestión en redes sociales." />

        <AboutItem img="https://img.icons8.com/ios/50/ffffff/z-fold-leaflet.png" text="Impresión de material gráfico publicitario." />

        <AboutItem img="https://img.icons8.com/ios/50/ffffff/magazine.png" text="Desarrollo editorial de revistas, coleccionables y libros." />

        <AboutItem img="https://img.icons8.com/ios/50/ffffff/signing-a-document.png" text="Contenidos para ediciones gráficas." />

        {/* <p className="list-item">Comercialización, contenidos y gestión en redes sociales</p> */}
        {/* <p className="list-item">Contenidos artísticos y periodísticos en general</p> */}

    
      </div>
    </section>
  );
}
